import { render, staticRenderFns } from "./architecture-drivers-rulesets.vue?vue&type=template&id=3b7e3c97"
import script from "./architecture-drivers-rulesets.vue?vue&type=script&lang=js"
export * from "./architecture-drivers-rulesets.vue?vue&type=script&lang=js"
import style0 from "./architecture-drivers-rulesets.vue?vue&type=style&index=0&id=3b7e3c97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports